import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M14.25 6V15.0386V17.5M14.25 13.2941C14.25 11.2353 15.4265 10.4118 16.8676 10.4118C18.4595 10.4118 19.75 11.6471 19.75 13.7059C19.75 15.7647 18.4595 16.75 16.8676 16.75C15.6908 16.75 14.25 15.7647 14.25 14.1176" />
		<Path d="M10.5 9.5C10.5 9.5 10.5 13.5533 10.5 14.7886C10.5 16.0239 10.6824 16.75 12 16.75M10.5 13.0441C10.5 10.9853 9.32353 10.1618 7.88235 10.1618C6.29047 10.1618 5 11.3971 5 13.4559C5 15.5147 6.29047 16.75 7.88235 16.75C9.0592 16.75 10.5 15.5147 10.5 13.8676" />
	</SVG>
);
